import React from 'react';
import { useTranslation } from 'react-i18next';

export function BoldConfig({ obj, handleBold, dataName }) {
  const { t } = useTranslation('common');
  return (
    <div className="pl-0 pr-2 py-3">
      <p className="mb-2 f-14 text-medium">&nbsp;</p>
      <div className="bold-check-control mr-2">
        <input type="checkbox" id={`${dataName}_bold`} onChange={handleBold} checked={obj?.otherConfiguration?.[dataName] === true} name={dataName} />
        <label htmlFor={`${dataName}_bold`} title={t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.BOLD_CONFIG.BOLD')}>
          <span className="icon-bold_new cursor-pointer" />
        </label>
      </div>
    </div>
  );
}

export default BoldConfig;
